import React, { Component } from 'react'
import Detalle from './Detalle'
export default {
    Detalle
}